export class AppConstants {
  public static readonly appIdleTimeoutInSeconds: number = 1800;
  public static readonly appInactivityTimeoutInSeconds: number = 300;
  public static readonly dbPagingDefaultRows: number = 20000;
  public static readonly defaultTableRows: number = 20;
  public static readonly defaultTextAreaRows: number = 5;
  public static readonly eventSteps = {
    event: 'event',
    locations: 'locations',
    people: 'people',
    attachments: 'attachments',
    summary: 'summary'
  };
  public static readonly fieldDivisionCount = 25;
  public static readonly filterDateDurationDays: number = 14;
  public static readonly defaultFilterPreferenceStorageKey: string = 'defaultFilterPreference';
  public static readonly defaultFilterYearRangeStart: string = '1980';
  public static readonly totalNumberOfUploadFilesAllowed: number = 50;
  public static readonly exportsDateRangeDurationDays: number = 30;
  public static showGlobalMsgDialog: boolean = false;


  public static get Result_FormTitle_Add(): string { return "Add Result"; };
  public static get Result_FormTitle_Edit(): string { return "Edit Result"; };

  public static get Result_FormMode_Add(): string { return "Add"; };
  public static get Result_FormMode_Edit(): string { return "Edit"; };

  public static get Result_Status_Draft(): string { return "Draft"; };
  public static get Result_Status_1stLineRejected(): string { return "1st Line Rejected"; }; // Previously Result_Status_Rejected
  public static get Result_Status_Pending1stLineApproval(): string { return "Pending 1st Line Approval"; }; // Previously Result_Status_Submitted
  public static get Result_Status_2ndLineRejected(): string { return "2nd Line Rejected"; };
  public static get Result_Status_Pending2ndLineApproval(): string { return "Pending 2nd Line Approval"; }; // Previously Result_Status_Approved
  public static get Result_Status_2ndLineApproved(): string { return "2nd Line Approved"; };

  public static get IR_FormMode_Add(): string { return "Add"; };
  public static get IR_FormMode_Edit(): string { return "Edit"; };
  public static get IR_FormMode_View(): string { return "View"; };
}
